module.exports = __webpack_public_path__ + "static/img/home47.f8a638a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/home47.png
// module id = ewD+
// module chunks = 0